"use client";
import React, { memo, useEffect, useState } from "react";
import { AppTextField } from "@/common";
import { AppConstant } from "@/const";
import { TextFieldProps } from "@mui/material";
import { SearchIcon } from "@/icons";
import { useDebouncedCallback } from "use-debounce";

const AppSearch = ({
  onChangeValue,
  hasEndIcon = false,
  value,
  timeDebounce = AppConstant.DEBOUNCE_TIME_IN_MILLISECOND,
  ...otherProps
}: AppSearchProps) => {
  const [valueCurrent, setValueCurrent] = useState(value || "");
  const handleChangeValueDebounce = useDebouncedCallback(
    (valueChange: string) => {
      if (onChangeValue instanceof Function) onChangeValue(valueChange);
    },
    timeDebounce
  );
  useEffect(() => {
    setValueCurrent(value?.toString() || "");
  }, [value]);
  return (
    <AppTextField
      value={valueCurrent}
      onChange={(event) => {
        const newValue = event.target.value;
        setValueCurrent(newValue);
        handleChangeValueDebounce(newValue);
      }}
      InputProps={
        hasEndIcon
          ? {
              endAdornment: <SearchIcon sx={{ fontSize: 24 }} />,
            }
          : {}
      }
      {...otherProps}
    />
  );
};

type AppSearchProps = Omit<TextFieldProps, "onChange"> & {
  onChangeValue?: (value: string) => void;
  hasEndIcon?: boolean;
  timeDebounce?: number;
};

export default memo(AppSearch);
